import { incomingCallState } from '../../models/callModel';
import { Types } from '../action/action';

const initialState = {
  status: false,
  incomingCallDetail:[]
};

export const incomingCallWindow = (state:incomingCallState  = initialState, action: any) => {
  const {
    type,
    payloads,
    callDetail
  } = action;
  switch (type) {
  case Types.INCOMING_CALL_POPUP:
    return {
      ...state, status: payloads, incomingCallDetail:callDetail
    };
  default:
    return state;
  };
};